<template>
  <span>
    <span v-if="status == true" class="badge badge-success">{{ $i18n.t('Sim') }}</span>
    <span v-else-if="status == false" class="badge badge-danger">{{ $i18n.t('Não') }}</span>
    <span v-else>--</span>
  </span>
</template>

<script>
export default {
  props: ['status']
};
</script>

<style lang="scss" scoped></style>
